(() => {
  const form = document.querySelector('[data-maria-cart]');
  if (!form) return;

  const checkout = form.querySelector('[data-cart-checkout]');
  const status = form.querySelector('[data-cart-status]');
  const refresh = form.querySelector('[data-cart-refresh]');
  const submitButtons = [...form.querySelectorAll('button[type="submit"]')];
  const lines = [...form.querySelectorAll('[data-gpo-cart-line-item-key]')].map(element => ({
    element,
    key: element.dataset.gpoCartLineItemKey,
    group: element.dataset.cartGroup,
    parentGroup: element.dataset.cartParentGroup,
    quantity: Number(element.dataset.cartQuantity),
    input: element.querySelector('[data-gpo-cart-line-item-qty]')
  }));
  const addons = lines.filter(line => line.parentGroup);
  const parentFor = addon => lines.find(line => line.group === addon.parentGroup);
  let removing = false;
  let submitting = false;

  // The vendor repairs old orphaned or mismatched service lines on page load.
  // Keep checkout closed during that repair, including before its lazy chunk loads.
  const groupsReady = addons.every(addon => {
    const parent = parentFor(addon);
    return parent && parent.quantity === addon.quantity;
  });

  const applyState = () => {
    checkout.disabled = removing || !groupsReady;
    form.setAttribute('aria-busy', String(removing));
    submitButtons.forEach(button => {
      if (button !== checkout) button.disabled = removing;
    });
    lines.forEach(line => { line.input.readOnly = removing; });
  };

  const mirrorQuantities = () => {
    addons.forEach(addon => {
      const parent = parentFor(addon);
      if (parent && parent.input && addon.input) addon.input.value = parent.input.value;
    });
  };

  if (!groupsReady) {
    status.textContent = 'Updating the services linked to your dress. Please refresh your bag if this message remains.';
    refresh.hidden = false;
  }
  applyState();
  mirrorQuantities();

  form.addEventListener('input', event => {
    if (event.target.matches('[data-gpo-cart-line-item-qty]')) mirrorQuantities();
  });
  form.addEventListener('change', event => {
    if (event.target.matches('[data-gpo-cart-line-item-qty]')) mirrorQuantities();
  });

  form.addEventListener('submit', event => {
    if (removing || submitting || !groupsReady) {
      event.preventDefault();
      return;
    }
    // Submit all linked quantities in the same native cart POST as the dress.
    mirrorQuantities();
    if (!form.checkValidity()) {
      event.preventDefault();
      form.reportValidity();
      return;
    }
    submitting = true;
    // Do not disable the successful submitter: Shopify needs name="checkout".
    submitButtons.forEach(button => button.setAttribute('aria-disabled', 'true'));
  });

  form.addEventListener('click', async event => {
    const removeLink = event.target.closest('[data-gpo-cart-line-item-remove-button]');
    if (!removeLink || !form.contains(removeLink)) return;
    if (removing || submitting) {
      event.preventDefault();
      return;
    }
    const line = lines.find(item => item.element.contains(removeLink));
    if (!line || !line.group) return;
    const linked = addons.filter(addon => addon.parentGroup === line.group);
    if (!linked.length) return;

    event.preventDefault();
    removing = true;
    applyState();
    status.textContent = 'Removing this dress and its linked services…';
    refresh.hidden = true;

    const updates = Object.fromEntries([line, ...linked].map(item => [item.key, 0]));
    const updateUrl = new URL(form.action);
    updateUrl.pathname = updateUrl.pathname.replace(/\/$/, '') + '/update.js';
    updateUrl.search = '';
    try {
      const response = await fetch(updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates })
      });
      const cart = await response.json();
      if (!response.ok || !Array.isArray(cart.items)) throw new Error('Unable to update your bag.');
      window.location.reload();
    } catch (error) {
      // An uncertain network response may already have changed the cart.
      // Require a refresh instead of submitting stale line-indexed quantities.
      form.setAttribute('aria-busy', 'false');
      status.textContent = 'We could not confirm the update. Please refresh your bag before continuing.';
      refresh.hidden = false;
    }
  });

  window.addEventListener('pageshow', event => {
    if (event.persisted && (addons.length || removing || submitting)) window.location.reload();
  });
})();
